// ...existing code...
import api from './api';
import { AiDifyCapability, AiDifyCapabilityCreatePayload, AiDifyCapabilityUpdatePayload, DirectusListResponse } from '../types/aiDifyCapability';

export interface DifyCapabilityListParams {
  readonly enabled?: boolean;
}

export interface DifyCapabilityService {
  getCapabilities(params?: DifyCapabilityListParams): Promise<ReadonlyArray<AiDifyCapability>>;
  createCapability(payload: AiDifyCapabilityCreatePayload): Promise<AiDifyCapability>;
  updateCapability(id: number, payload: AiDifyCapabilityUpdatePayload): Promise<AiDifyCapability>;
  deleteCapability(id: number): Promise<void>;
  toggleEnabled(id: number, enabled: boolean): Promise<AiDifyCapability>;
}

class DifyCapabilityServiceImpl implements DifyCapabilityService {
  private readonly _basePath: string = '/items/ai_dify_capability';

  public async getCapabilities(params?: DifyCapabilityListParams): Promise<ReadonlyArray<AiDifyCapability>> {
    try {
      const query: any = {};

      if (typeof params?.enabled === 'boolean') {
        // Directus 过滤格式：filter[enabled][_eq]=true
        query.filter = {
          enabled: {
            _eq: params.enabled
          }
        };
      }

      const response: DirectusListResponse<AiDifyCapability> = await api.get<DirectusListResponse<AiDifyCapability>>(
        this._basePath,
        { params: query }
      );

      return response?.data ?? [];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('获取 Dify 能力配置列表失败:', error);
      throw error;
    }
  }

  public async createCapability(payload: AiDifyCapabilityCreatePayload): Promise<AiDifyCapability> {
    try {
      const result: AiDifyCapability = await api.post<AiDifyCapability>(this._basePath, payload);
      return result;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('创建 Dify 能力配置失败:', error, payload);
      throw error;
    }
  }

  public async updateCapability(id: number, payload: AiDifyCapabilityUpdatePayload): Promise<AiDifyCapability> {
    try {
      const result: AiDifyCapability = await api.patch<AiDifyCapability>(`${this._basePath}/${id}`, payload);
      return result;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('更新 Dify 能力配置失败:', { id, payload, error });
      throw error;
    }
  }

  public async deleteCapability(id: number): Promise<void> {
    try {
      await api.delete<void>(`${this._basePath}/${id}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('删除 Dify 能力配置失败:', id, error);
      throw error;
    }
  }

  public async toggleEnabled(id: number, enabled: boolean): Promise<AiDifyCapability> {
    return this.updateCapability(id, { enabled });
  }
}

const difyCapabilityService: DifyCapabilityService = new DifyCapabilityServiceImpl();
export default difyCapabilityService;
// ...existing code...